import classNames         from 'classnames';
import * as PropTypes     from 'prop-types';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import useOnClickOutside from '../../../../common/hooks/useOnClickOutside';

import SelectArrowIcon from '../../icons/SelectArrowIcon';

const Dropdown = function(props) {
  const { t } = useTranslation();

  const {
          labelKey = 'labelKey',
          onChangeCallback,
          options,
          placeholder = 'placeholder_set',
          prefix,
          required = true,
          selected,
          valueKey = 'valueKey',
        } = props;

  const dropdownRef = React.useRef(null);

  const [open, setOpen] = React.useState(false);

  useOnClickOutside(dropdownRef, () => open && setOpen(false));

  const label = React.useMemo(() => {
    const option = options.find((item) => {
      return item[valueKey] === selected;
    });

    if (!option) {
      return t(placeholder);
    }

    return [
      t(prefix),
      option[labelKey],
    ]
      .join(' ')
      .trim();
  }, [labelKey, options, placeholder, selected, valueKey]);

  const handleChange = React.useCallback((event, index) => {
    event.preventDefault();
    event.stopPropagation();

    onChangeCallback?.(index !== selected ? index : null);

    setOpen(false);
  }, [onChangeCallback, selected]);
  const toggleState  = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    if (options.length !== 0) {
      setOpen((open) => !open);
    }
  }, [options]);

  return (
    <div
      className={classNames('dropdown', { open })}
      ref={dropdownRef}
    >
      <span
        className={'selected'}
        onClick={toggleState}
        title={label}
      >
        <span>{label}</span>
        <SelectArrowIcon />
      </span>
      <ul className={classNames({ open })}>
        {!required && (
          <li
            className={classNames({ 'selected': selected === null })}
            onClick={(event) => {
              handleChange(event, null);
            }}
            title={t(placeholder)}
          >{t(placeholder)}</li>
        )}
        {options.map((option, o) => (
          <li
            className={classNames({ 'selected': selected === option[valueKey] })}
            key={o}
            onClick={(event) => {
              handleChange(event, option[valueKey]);
            }}
            title={option[labelKey]}
          >{option[labelKey]}</li>
        ))}
      </ul>
    </div>
  );
};

Dropdown.propTypes = {
  selected:         PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options:          PropTypes.array,
  placeholder:      PropTypes.string,
  prefix:           PropTypes.string,
  valueKey:         PropTypes.string,
  labelKey:         PropTypes.string,
  onChangeCallback: PropTypes.func.isRequired,
};

export default Dropdown;